module.exports = __webpack_public_path__ + "static/media/ws.da8ebe42.png";